<div class="two-columns"
    :class="flip ? 'two-columns--flipped' : null">
    <div class="two-columns__col">
        <img :src="imagePath" alt="">
    </div>
    <div class="two-columns__col">
        <div class="two-columns__title" v-html="title"></div>
        <div class="two-columns__description" v-html="description"></div>
    </div>
</div>